import _toConsumableArray from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Helpers
import { mapState } from 'vuex';
export default {
  name: 'TheSearch',
  props: {
    placeholder: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      inputValue: '',
      products: []
    };
  },
  computed: _objectSpread({}, mapState(['notification', 'cookiesWereAccepted'])),
  mounted: function mounted() {
    this.focusInput();
    this.fetch();
  },
  methods: {
    closeSearch: function closeSearch() {
      this.$store.commit("setState", {
        key: "searchIsActive",
        value: false
      });
    },
    focusInput: function focusInput() {
      this.$refs.searchInput.focus();
    },
    fetch: function fetch() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var limit, products;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                limit = 24; // Set preload data

                _this.products = _toConsumableArray(Array(4).keys());
                _context.next = 4;
                return _this.$swell.products.list({
                  search: _this.inputValue,
                  limit: limit,
                  sort: 'popularity asc',
                  expand: ['variants']
                });

              case 4:
                products = _context.sent;
                _this.products = products.results;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};